import ms from 'ms';
import Vue from 'vue';

import Module from '@/scripts/old/classes/Module';
import { parseAttr } from '@/scripts/old/helpers/utils';

import Countdown from './Countdown.vue';

const NAMESPACE = 'data-countdown';

class CountdownsModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const mountingPoint = document.createElement('div');
    el.appendChild(mountingPoint);

    let timestamp = parseAttr(el, NAMESPACE) || Date.now();
    let doneText = parseAttr(el, 'data-countdown-doneText') || '';

    if (typeof timestamp === 'string') {
      timestamp = Date.now() + ms(timestamp);
    }

    const countdown = new Vue({
      el: mountingPoint,
      render(h) {
        return h(Countdown, {
          props: {
            timestamp,
            doneText
          },
        });
      },
    });

    this.instances.set(el, countdown);
  }

  destroyInstance(instance) {
    instance.$destroy();
    instance.$el.parentElement.removeChild(instance.$el);
  }
}

export default new CountdownsModule();
